
export const locale = {
  'DIALOG' : {
    'LOGISTICIAN' : {
      'TITLE' : {
        'CREATE' : 'Создать диспетчера',
        'EDIT' : 'Редактировать диспетчера',
      },
      'CONFIRMBUTTON' : {
        'CREATE' : 'Создать',
        'SAVE' : 'Сохранить',
      },
      'FULLNAME' : 'ФИО',
    },
    'ERROR' : {
      'ALREADYEXISTS' : 'Невозможно создать аккаунт, т.к. уже существует аккаунт с таким логином',
    }
  },
};
